import DriveSidebar from 'components/layout/DriveSidebar'
import { useSelector, useDispatch } from 'react-redux'
import Panel, { PanelSpacer, PanelTitle } from 'components/layout/Panel'
import Helmet from 'react-helmet'
import Page from 'rui/widgets/Page'
import { LicenseInfoCard } from '../DrivingInfo/LicenseInfo'
import { Icon } from 'roadie-ui'
import { PersonalInfoForm } from './BasicInfoRegistration'
import { BusinessInfoForm } from './BusinessInfo'
import { ProfileBasicInfo } from 'types/profile'
import { useLocalization, LocalizedText } from 'localization'

const BasicInfoPage: React.FC<{ registered: boolean }> = (props) => {
  const { t } = useLocalization()
  const isWebView = useSelector<any, boolean>((state) => state.config.isWebview)
  const profile = useSelector<any, ProfileBasicInfo>((state) => state.profile)
  const isLocked = useSelector<any, number>((state) => state.isLocked)
  const dispatch = useDispatch()

  const latestEINData = profile.ein_verifications.at(-1)

  return (
    <Page sidebar={<DriveSidebar />}>
      <Helmet>
        <title>{t('dweb_layout_drive_sidebar_basic_info')}</title>
      </Helmet>
      {!isWebView && (
        <PanelTitle>
          <LocalizedText translationKey="dweb_layout_drive_sidebar_basic_info" />
        </PanelTitle>
      )}
      <Panel left noPadding>
        <Panel noPadding bottomBorderOnly>
          <LicenseInfoCard
            icon={<Icon.License />}
            title={t('dweb_account_basic_info_personal_info')}
            info={<LocalizedText translationKey="dweb_account_basic_info_name_dob_current_address" />}
          >
            {() => (
              <PersonalInfoForm
                profile={profile}
                dispatch={dispatch}
                registered={props.registered}
                isLocked={isLocked}
              />
            )}
          </LicenseInfoCard>
        </Panel>
        <LicenseInfoCard
          icon={<Icon.VehicleTruck />}
          title={t('dweb_account_basic_info_registration_business_info')}
          info={
            latestEINData?.ein_verification.business_name ?? (
              <LocalizedText translationKey="dweb_account_basic_info_add_business_name_ein" />
            )
          }
          formIsEmpty={!profile.ein_verifications.length}
        >
          {() => <BusinessInfoForm einVerification={latestEINData} />}
        </LicenseInfoCard>
      </Panel>
      <PanelSpacer />
    </Page>
  )
}

export default BasicInfoPage
